import React, { useEffect, useRef, useState } from "react";
import PageLayout from "../../layoutcontainers/PageLayout";
import MaterialBox from "../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import bgImage from "../../assest/images/logo.png";
import track from "../../assest/HRMS_IMG.png";
import logo from "../../assest/images/logo.png";
import assets from "../../config/assestsConfig";
import Reveal from "../../animations/Reveal";
import MaterialTypography from "../../components/MaterialTypography";
import { Box, Card, LinearProgress, Stack } from "@mui/material";
import heroImage from "../../assest/images/login-frontend.jpg";
import loginImage1 from "../../assest/images/HRMS-Login-1.svg";
import loginImage2 from "../../assest/images/HRMS-Login-2.svg";
import loginImage3 from "../../assest/images/HRMS-Login-3.svg";
import loginImage4 from "../../assest/images/HRMS-Login-4.svg";

const images = [loginImage1, loginImage2, loginImage3, loginImage4];
const INTERVAL = 5000; // 5 seconds per slide

const LogInLayout = ({ title, subtitle, children }) => {
  const imageCount = images.length;
  const [activeIndex, setActiveIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const progressRef = useRef();

  useEffect(() => {
    // Progress animation
    progressRef.current = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress >= 100) {
          setActiveIndex((prev) => (prev + 1) % images.length);
          return 0;
        }
        return oldProgress + 1;
      });
    }, INTERVAL / 100); // smooth progress

    return () => clearInterval(progressRef.current);
  }, []);

  useEffect(() => {
    setProgress(0);
  }, [activeIndex]);

  return (
    <PageLayout height="100%" showNavbar>
      <MaterialBox bgColor="white" p={0} pl={25} pr={25}>
        <Box
          sx={{
            width: "calc(100% - 2rem)",
            height: "calc(100vh - 2rem)",
            borderRadius: 2,
            overflow: "hidden",
            // boxShadow: 4,
            backgroundColor: "#fff",
          }}
        >
          <MaterialBox
            variant="gradient"
            bgColor="white"
            position="relative"
            borderRadius="xl"
            mx={{ xs: 2, xl: 3, xxl: 16 }}
            // mt={-35}
            sx={{ overflow: "hidden" }}
          >
            <Grid
              container
              display="flex"
              justifyContent="center"
              alignItems="center"
              p={6}
            >
              <Grid
                size={{ xs: 12, md: 5, lg: 5 }}
                mr="auto"
                position="relative"
              >
                <MaterialBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <img
                    src={assets.logo}
                    alt="Image not loaded"
                    style={{
                      width: "40%",
                      height: "40%",
                      justifyContent: "center",
                      textAlign: "center",
                      alignItems: "center",
                      borderRadius: "0px",
                    }}
                  />
                </MaterialBox>
                <MaterialBox
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  px={3}
                  mt={2}
                  justifyContent="center"
                >
                  <MaterialTypography
                    variant="h4"
                    fontWeight="bold"
                    textAlign="center"
                    color="black"
                  >
                    {title}
                  </MaterialTypography>
                </MaterialBox>
                <MaterialBox
                  display="flex"
                  alignItems="center"
                  flexDirection="column"
                  px={3}
                  mb={1}
                  justifyContent="center"
                >
                  <MaterialTypography
                    variant="body2"
                    textAlign="center"
                    color="black"
                  >
                    {subtitle}
                  </MaterialTypography>
                </MaterialBox>

                <MaterialBox p={2} display="flex" flexDirection="column">
                  {children}
                </MaterialBox>
              </Grid>
              <Grid
                size={{ xs: 12, md: 7 }}
                position="absolute"
                left="42%"
                // mr={-32}
                width="75%"
              >
                <Box
                  p={5}
                  sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 2,
                    overflow: "hidden",
                    backgroundColor: "#fff",
                  }}
                >
                  {/* Slider Image */}
                  <Box
                    component="img"
                    src={images[activeIndex]}
                    alt={`slide-${activeIndex}`}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "opacity 0.5s ease-in-out",
                    }}
                  />

                  {/* Progress Bar */}
                  <MaterialBox
                    sx={{
                      position: "absolute",
                      bottom: { xs: "4%", sm: "6%", md: "8%" },
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 2,
                    }}
                  >
                    <Stack direction="row" spacing={1}>
                      {images.map((_, index) => (
                        <MaterialBox
                          key={index}
                          onClick={() => setActiveIndex(index)}
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor:
                              activeIndex === index ? "#0B1D51" : "gray",
                            opacity: activeIndex === index ? 1 : 0.6,
                            transition: "all 0.3s ease-in-out",
                            cursor: "pointer",
                            "&:hover": {
                              opacity: 1,
                            },
                          }}
                        />
                      ))}
                    </Stack>
                  </MaterialBox>
                </Box>
              </Grid>
            </Grid>
          </MaterialBox>
        </Box>
      </MaterialBox>
    </PageLayout>
  );
};

export default LogInLayout;
